"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIAnalytics = void 0;
const helpers_1 = require("./helpers");
const BIAnalytics_type_1 = require("../../utils/BIAnalytics/BIAnalytics.type");
class BIAnalytics {
    static arriveAtTimecard() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.ARRIVE_AT_TIMECARD);
    }
    static goToPreviousPayPeriod() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.GO_TO_PREVIOUS_PAY_PERIOD, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_PICKER);
    }
    static goToNextPayPeriod() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.GO_TO_NEXT_PAY_PERIOD, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_PICKER);
    }
    static clickOnDayWithAnomalies() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_ON_DAY_WITH_ANOMALIES, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_DAILY_BREAKDOWN);
    }
    static clickOnDayWithoutAnomalies() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_ON_DAY_WITHOUT_ANOMALIES, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_DAILY_BREAKDOWN);
    }
    static clickSeeTodayButton() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_SEE_TODAY_BUTTON, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_DAILY_BREAKDOWN);
    }
    static clickRequestCorrectionButton() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_REQUEST_CORRECTION_BUTTON, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_HOURLY_BREAKDOWN);
    }
    static RCModalCorrectUnpaidTimeOrAttendance() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.RCMODAL_CORRECT_UNPAID_TIME_OR_ATTENDANCE, BIAnalytics_type_1.SubPageNames.REQUEST_CORRECTION_MODAL);
    }
    static RCModalCorrectTimeOffRequests() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.RCMODAL_CORRECT_TIME_OFF_REQUESTS, BIAnalytics_type_1.SubPageNames.REQUEST_CORRECTION_MODAL);
    }
    static RCModalViewPunchCorrectionRequests() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.RCMODAL_VIEW_PUNCH_CORRECTION_REQUESTS, BIAnalytics_type_1.SubPageNames.REQUEST_CORRECTION_MODAL);
    }
    static RCModalReportAbsenceLateness() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.RCMODAL_REPORT_ABSENCE_LATENESS, BIAnalytics_type_1.SubPageNames.REQUEST_CORRECTION_MODAL);
    }
    static RCModalCloseModal() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.RCMODAL_CLOSE_MODAL, BIAnalytics_type_1.SubPageNames.REQUEST_CORRECTION_MODAL);
    }
    static clickUnpaidTimeDetails() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_UNPAID_TIME_DETAILS, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_HOURLY_BREAKDOWN);
    }
    static clickSeePayLink() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_SEE_PAY_LINK, BIAnalytics_type_1.SubPageNames.PAY_PERIOD_PICKER);
    }
    static visitTaskListFromTimecard() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.VISIT_TASK_LIST_FROM_TIMECARD);
    }
    static arriveAtTaskList() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.ARRIVE_AT_TASK_LIST, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickTaskListLearnMore() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_TASK_LIST_LEARN_MORE, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickNotAcceptedRequest() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_NOT_ACCEPTED_REQUEST, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickDuplicatedPunch() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_DUPLICATED_PUNCH, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickMissingPunch() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_MISSING_PUNCH, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickSystemAddedPunch() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_SYSTEM_ADDED_PUNCH, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickPendingRequest() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_PENDING_REQUEST, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static clickAcceptedRequest() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CLICK_ACCEPTED_REQUEST, BIAnalytics_type_1.SubPageNames.TASK_LIST);
    }
    static PCSModalCloseModal() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.PCSMODAL_CLOSE_MODAL, BIAnalytics_type_1.SubPageNames.PUNCH_CORR_STATUS_MODAL);
    }
    static selectDateInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CHANGE_CALENDAR_DATE, BIAnalytics_type_1.SubPageNames.SELECT_DATE);
    }
    static selectActionInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_PUNCH_ACTION, BIAnalytics_type_1.SubPageNames.SELECT_ACTION);
    }
    static selectPunchInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_PUNCH, BIAnalytics_type_1.SubPageNames.SELECT_PUNCH);
    }
    static changePunchTimeInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CHANGE_PUNCH_TIME, BIAnalytics_type_1.SubPageNames.EDIT_PUNCH);
    }
    static changePunchDateInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CHANGE_PUNCH_DATE, BIAnalytics_type_1.SubPageNames.EDIT_PUNCH);
    }
    static submitPunchWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.SUBMIT_PUNCH_WORKFLOW, BIAnalytics_type_1.SubPageNames.REVIEW);
    }
    static closePunchWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CLOSE_PUNCH_WORKFLOW);
    }
    static clickBackInPunchWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_BACK);
    }
    static clickContinueInPunchWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_CONTINUE);
    }
    static arriveSelectDateInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_SELECT_DATE_STEP, BIAnalytics_type_1.SubPageNames.SELECT_DATE);
    }
    static arriveSelectActionInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_SELECT_ACTION_STEP, BIAnalytics_type_1.SubPageNames.SELECT_ACTION);
    }
    static arriveSelectPunchInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_SELECT_PUNCH_STEP, BIAnalytics_type_1.SubPageNames.SELECT_PUNCH);
    }
    static arriveEditPunchInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_EDIT_PUNCH_STEP, BIAnalytics_type_1.SubPageNames.EDIT_PUNCH);
    }
    static arriveReviewInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_REVIEW_STEP, BIAnalytics_type_1.SubPageNames.REVIEW);
    }
    static arriveSummaryInPW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.PUNCH_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_SUMMARY_STEP, BIAnalytics_type_1.SubPageNames.SUMMARY);
    }
    static arriveReportTravelTimeStepInRTTW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_REPORT_TRAVEL_TIME_STEP, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static arriveReportTravelTimeReviewStepInRTTW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_REPORT_TRAVEL_TIME_REVIEW_STEP, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME_REVIEW);
    }
    static arriveReportTravelTimeSummaryStepInRTTW() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_REPORT_TRAVEL_TIME_SUMMARY_STEP, BIAnalytics_type_1.SubPageNames.SUMMARY);
    }
    static changeTravelStartDateInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_START_DATE_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static changeTravelStartTimeInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_START_TIME_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static changeTravelEndDateInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_END_DATE_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static changeTravelEndTimeInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_END_TIME_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static changeTravelMealStartTimeInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_MEAL_START_TIME_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static changeTravelMealDurationInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_MEAL_DURATION_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static changeTravelReasonInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.TRAVEL_REASON_CHANGE, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME);
    }
    static submitReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.SUBMIT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.SubPageNames.REPORT_TRAVEL_TIME_REVIEW);
    }
    static closeReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.CLOSE_TRAVEL_TIME_WORKFLOW);
    }
    static clickBackInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_BACK);
    }
    static clickContinueInReportTravelTimeWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPORT_TRAVEL_TIME_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_CONTINUE);
    }
    static clickOnAcknowledgeButtonInTimeCard() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.OPEN_ACKNOWLEDGEMENT_FORM);
    }
    static clickOnAcknowledgeButtonInAcknowledgeForm() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.ACKNOWLEDGE_ACKNOWLEDGEMENT_FORM);
    }
    static clickOnCancelButtonInAcknowledgeForm() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.TIMECARD, BIAnalytics_type_1.PageActions.CANCEL_ACKNOWLEDGEMENT_FORM);
    }
    static clickOnBackButtonInReplaceVTOWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPLACE_VTO_WORKFLOW, BIAnalytics_type_1.PageActions.CLICK_BACK);
    }
    static clickOnCloseButtonInReplaceVTOWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPLACE_VTO_WORKFLOW, BIAnalytics_type_1.PageActions.CLOSE_REPLACE_VTO_WORKFLOW);
    }
    static arriveInReplaceVTOForm() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPLACE_VTO_WORKFLOW, BIAnalytics_type_1.PageActions.REPLACE_VTO_WORKFLOW_FORM, BIAnalytics_type_1.SubPageNames.REPLACE_VTO_WORKFLOW);
    }
    static clickContinueInReplaceVTOWorkflow() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPLACE_VTO_WORKFLOW, BIAnalytics_type_1.PageActions.REPLACE_VTO_WORKFLOW_CONTINUE);
    }
    static arriveSummaryInReplaceVTOWF() {
        (0, helpers_1.sendEngagementMetric)(BIAnalytics_type_1.PageNames.REPLACE_VTO_WORKFLOW, BIAnalytics_type_1.PageActions.ARRIVE_SUMMARY_STEP, BIAnalytics_type_1.SubPageNames.SUMMARY);
    }
}
exports.BIAnalytics = BIAnalytics;
exports.default = BIAnalytics;
